
export const trackEvent = (eventType) => {
  if (eventType && window.metrical) {
    console.log('window.metrical', window.metrical);
    window.metrical.trackEvent(eventType);
  }
};

export default { trackEvent };
